import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgTableColumns = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 14 14"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M5.5 12.5V9.75h7V12c0 .275-.225.5-.5.5zm-1.5 0H2a.5.5 0 0 1-.5-.5V9.75H4zM0 8.25V12c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2H2C.897 0 0 .897 0 2zm1.5-2.5H4v2.5H1.5zm0-1.5V2c0-.275.225-.5.5-.5h2v2.75zm4-2.75H12c.275 0 .5.225.5.5v2.25h-7zm7 4.25v2.5h-7v-2.5z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTableColumns);
export default ForwardRef;
